module.exports = __webpack_public_path__ + "img/johan_cv_2.831e7474.jpg";